import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { OldSolutionsSection } from './components/OldSolutionsSection';
import { MechanismSection } from './components/MechanismSection';
import { WhatsInsideSection } from './components/WhatsInsideSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: (...args: any[]) => void;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (typeof window === 'undefined') return;
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    window.fbq('init', '1938522000081134');
    window.fbq('track', 'PageView');
    // Noscript fallback
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1938522000081134&ev=PageView&noscript=1';
    document.body.appendChild(img);
    return () => {
      if (img.parentNode) img.parentNode.removeChild(img);
    };
  }, []);
  return <div className="w-full min-h-screen" style={{
    backgroundColor: '#0a0a0f'
  }} data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <OldSolutionsSection data-id="element-3" />
      <MechanismSection data-id="element-4" />
      <WhatsInsideSection data-id="element-5" />
      <OfferSection data-id="element-6" />
      <GuaranteeSection data-id="element-7" />
      <FinalCTA data-id="element-8" />
      <Footer data-id="element-9" />
    </div>;
}